import { Box, Link, Text } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  Link,
  Text,
  React
};